import {
  customScrollMinimal,
  Drawer,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

import { EntityHeaderWatchlist } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/entity-header-watchlist/EntityHeaderWatchlist';

export const StyledDrawer = styled(Drawer)`
  [data-drawer-header] {
    background-color: var(--background-default);
  }

  [data-drawer-container] {
    width: 788px;
  }
`;

export const StyledEntityHeaderWatchlist = styled(EntityHeaderWatchlist)`
  padding-left: 8px;
  margin-bottom: 8px;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  padding: 20px;
  ${customScrollMinimal};
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const Label = styled.p`
  ${typographyV2.uiSm};
  color: var(--text-primary);
  text-align: left;
`;
